import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class PageHeaderLoader extends Component {
    render() {
        const { bottom_bordered, container_class } = this.props;

        return (
            <div className={classNames(`ori-full-width ori-flex-row ori-flex-jsb ori-tb-pad-15 oriPageHeaderLoaderContainer ${container_class}`, { "ori-b-border-light": bottom_bordered, })}>
                <div className="ori-height-lg ori-card-loading width4">&nbsp;</div>
                <div className="ori-height-lg ori-card-loading ori-border-radius-20 width3">&nbsp;</div>
            </div>
        );
    }
}

PageHeaderLoader.propTypes = {
    bottom_bordered: PropTypes.bool,
    container_class: PropTypes.string,
};

PageHeaderLoader.defaultProps = {
    bottom_bordered: false,
};

export default PageHeaderLoader;


// WEBPACK FOOTER //
// ./src/components/pageheader/loaders/index.js